import {
  buildAdminListQuery,
  type TAdminListParams,
} from '@/core/lib/table-query'

export const teamEndpoints = {
  list: (params: TAdminListParams) =>
    `/admin/teams?${buildAdminListQuery(params)}`,
  detail: (id: string) => `/admin/teams/${id}`,
  updateStatus: (id: string) => `/admin/teams/${id}/status`,
  delete: (id: string) => `/admin/teams/${id}`,
  pendingLogoRequests: () => `/admin/teams/logo-requests/pending`,
  approveLogoRequest: (id: string) =>
    `/admin/teams/logo-requests/${id}/approve`,
  refuseLogoRequest: (id: string) => `/admin/teams/logo-requests/${id}/refuse`,
}

export const teamBackendErrors = {
  TEAM_NOT_FOUND: 'Takım bulunamadı.',
  ADMIN_TEAM_NOT_FOUND: 'Takım bulunamadı.',
  ADMIN_TEAM_EDIT: 'Takım durumu güncellenirken hata oluştu.',
  ADMIN_TEAM_DELETE: 'Takım silinirken hata oluştu.',
  GENERAL_ERROR: 'Beklenmeyen bir hata oluştu.',
} as const

export const teamSuccessMessages = {
  teamStatusUpdate: 'Takım durumu başarıyla güncellendi.',
  teamDelete: 'Takım başarıyla silindi.',
  logoApproved: 'Logo talebi onaylandı.',
  logoRefused: 'Logo talebi reddedildi.',
} as const
